module.exports = __webpack_public_path__ + "img/hitogata_4w.989c5623.png";